import angular from 'angular';

angular
  .module('cloudX')
  .controller('CheckboxListDialogCtrl', [
    '$scope',
    'appMessages',
    'close',
    'title',
    'items',
    checkboxListDialogCtrl,
  ]);

function checkboxListDialogCtrl($scope, appMessages, close, title, items) {
  $scope.title = appMessages(title);
  $scope.items = angular.copy(items);
  $scope.selectAll = $scope.items.every(x => x.selected);

  $scope.selectAllChanged = function() {
    $scope.items.forEach(item => {
      item.selected = $scope.selectAll;
    });
  };
  $scope.itemChanged = function(item) {
    $scope.selectAll = item.selected && $scope.items.every(x => x.selected);
  };

  $scope.close = function(result) {
    if (result) {
      close($scope.items, 500);
    } else {
      close(null, 500);
    }
  };
}
